@if (puffDataToUse() && puffDataToUse().acf) {
  <div class="vd-card vd-card-white puff-container">
    @if (hasImage()) {
      <div class="puff-image-container">
        <app-media-item
          [image]="
        puffDataToUse().featured_media ? null : puffDataToUse().acf.backgroundImageMobile
      "
          [isNarrowColumnImage]="true"
          [isPriority]="index() === 0"
          [routePath]="routePath()"
        ></app-media-item>
      </div>
    }

    <div [ngClass]="contentCssClass()" class="puff-text-container">
      <a
        [innerHTML]="puffDataToUse().title.rendered"
        [ngClass]="titleCssClass()"
        [routerLink]="routePath()"
        class="block text-left text-xl font-bold"
      ></a>

      <div [innerHtml]="puffDataToUse().acf.description"
           class="vd-card-content">
      </div>
    </div>
  </div>
}

